<app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">
  @if (currentString) {
  <form [formGroup]="form.formGroup">
    
    <div class="flex flex-col mt-1">
      <label for="type">Type</label>
      <p-select
        [options]="operationTypes"
        [formControlName]="form.formControlNames.type"
        optionLabel="name"
        appendTo="body"
        optionValue="value"
        (onChange)="onTypeChanged()"
      ></p-select>
    </div>

    <div class="pt-5">
      @switch (form.formGroup.value.type) {
        @case (OperationType.PRODUCTION) {
          <app-production-operation-details
            [isReadOnly]="isReadOnly"
            [formControlName]="form.formControlNames.productionOperation"
            [fluids]="fluids$"
            [perforation]="perforations"
            [userUnits]="units"
            [reservoirs]="reservoirs"
            [chokes]="chokes"
            [currentTubularIndex]="currentTubularIndex"
            [isSubsea]="wellType?.type === 'Subsea'"
            [drillString]="drillString"
            [defaultRiser]="riser"
            [showLandingString]="showLandingString"
            [pericalOptions]="pericalOptions"
            (fluidChanged)="onFluidChange($event)"
            (selectedTabChange)="selectedTabChange.emit($event)"
            [surfaceTemperature]="surfaceTemperature"
          ></app-production-operation-details>
        }
        @case (OperationType.INJECTION) {
          <app-injection-operation-details
            [isReadOnly]="isReadOnly"
            [formControlName]="form.formControlNames.injectionOperation"
            [fluids]="fluids$"
            [perforations]="perforations"
            [surfaceTemperature]="surfaceTemperature"
            [user]="user"
            [userUnits]="units"
            [showLandingString]="showLandingString"
            [reservoirs]="reservoirs"
            [chokes]="chokes"
            [currentTubularIndex]="currentTubularIndex"
            [isSubsea]="wellType?.type === 'Subsea'"
            [drillString]="drillString"
            [defaultRiser]="riser"
            [pericalOptions]="pericalOptions"
            (fluidChanged)="onFluidChange($event)"
            (selectedTabChange)="selectedTabChange.emit($event)"
            [showRestartOperation]="showRestartOperation"
          ></app-injection-operation-details>
        }
        @case (OperationType.SHUTIN) {
          <app-shut-in-operation-details
            [isReadOnly]="isReadOnly"
            [formControlName]="form.formControlNames.shutInOperation"
            [currentString]="currentString"
            [defaultHangerPressure]="defaultScreenoutHangerPressure ?? defaultHangerPressure"
            [isAnnulus]="tabType === 'annulus'"
            [currentTubularIndex]="currentTubularIndex"
            [defaultRiser]="riser"
            [showLandingString]="showLandingString"
            [drillString]="drillString"
            [isSubsea]="wellType?.type === 'Subsea'"
            [user]="user"
          ></app-shut-in-operation-details>
        }
        @case (OperationType.CIRCULATION) {
          <app-circulation-operation-details
            [isReadOnly]="isReadOnly"
            [formControlName]="form.formControlNames.circulationOperation"
            [fluids]="fluids$"
            [previousOperationMudPits]="previousOperationMudPits"
            [currentTubularIndex]="currentTubularIndex"
            [isSubsea]="wellType?.type === 'Subsea'"
            [drillString]="drillString"
            [defaultRiser]="riser"
            [userUnits]="units"
            [surfaceTemperature]="surfaceTemperature"
            [showLandingString]="showLandingString"
            [maxCircDepth]="maxCircDepth"
            [previousOperationMudPits]="previousOperationMudPits"
            (selectedTabChange)="selectedTabChange.emit($event)"
            [hangerMd]="currentString?.hangerMd"
          ></app-circulation-operation-details>
        }
        @case (OperationType.GASLIFT) {
          <app-gas-lift-details
            [formControlName]="form.formControlNames.gasLiftOperation"
            [fluids]="fluids$"
            [currentString]="currentString"
            [userUnits]="user.units"
            [surfaceTemperature]="surfaceTemperature"
          ></app-gas-lift-details>
        }
        @case (OperationType.DRILLING) {
          <app-drilling-operation-details
            [wellConfig]="tubulars"
            [isReadOnly]="isReadOnly"
            [formControlName]="form.formControlNames.drillingOperation"
            [fluids]="fluids$"
            [previousOperationMudPits]="previousOperationMudPits"
            [annularFluidId]="annularFluidId"
            (drillingRangeChanged)="onDrillingDepthRangeChange($event)"
            [userUnits]="units"
            [currentStringId]="currentString.id"
            [wellType]="wellType"
            [defaultRiser]="riser"
            [surfaceTemperature]="surfaceTemperature"
            [currentTubularIndex]="currentTubularIndex"
            (selectedTabChange)="selectedTabChange.emit($event)"
            [triggerMudPitTempChange]="triggerMudPitTempChange"
          ></app-drilling-operation-details>
        }
        @case (OperationType.RUNCASINGANDCIRCULATE) {
          <app-run-casing-and-circulate-details
            [isReadOnly]="isReadOnly"
            [formControlName]="form.formControlNames.runCasingAndCirculate"
            [fluids]="fluids$"
            [previousOperationMudPits]="previousOperationMudPits"
            [annularFluidId]="annularFluidId"
            [userUnits]="units"
            [defaultRiser]="riser"
            [isSubsea]="wellType?.type === 'Subsea'"
            [currentString]="currentString"
            [surfaceTemperature]="surfaceTemperature"
            [currentTubularIndex]="currentTubularIndex"
            (selectedTabChange)="selectedTabChange.emit($event)"
            [triggerMudPitTempChange]="triggerMudPitTempChange"
          ></app-run-casing-and-circulate-details>
        }
        @case (OperationType.TRIPPIPEANDCIRCULATE) {
          <app-trip-pipe-and-circulate-details
            [wellConfig]="tubulars"
            [isReadOnly]="isReadOnly"
            [formControlName]="form.formControlNames.tripPipeAndCirculate"
            [previousOperationMudPits]="previousOperationMudPits"
            [fluids]="fluids$"
            [annularFluidId]="annularFluidId"
            [userUnits]="units"
            [currentString]="currentString"
            [surfaceTemperature]="surfaceTemperature"
            [currentTubularIndex]="currentTubularIndex"
            [isSubsea]="wellType?.type === 'Subsea'"
            (selectedTabChange)="selectedTabChange.emit($event)"
            [triggerMudPitTempChange]="triggerMudPitTempChange"
          ></app-trip-pipe-and-circulate-details>
        }
        @case (OperationType.CEMENTING) {
          <app-cementing-operation-details
            [isReadOnly]="isReadOnly"
            [formControlName]="form.formControlNames.cementingOperation"
            [fluids]="fluids$"
            [previousOperationMudPits]="previousOperationMudPits"
            [annularFluidId]="annularFluidId"
            [userUnits]="units"
            [defaultRiser]="riser"
            [isSubsea]="wellType?.type === 'Subsea'"
            [currentString]="currentString"
            [currentTubularIndex]="currentTubularIndex"
            [surfaceTemperature]="surfaceTemperature"
            (selectedTabChange)="selectedTabChange.emit($event)"
          ></app-cementing-operation-details>
        }
        @case (OperationType.SCREENOUT) {
          <app-screenout-operation-details
            [isReadOnly]="isReadOnly"
            [formControlName]="form.formControlNames.screenoutOperation"
            [currentTubularIndex]="currentTubularIndex"
            [isSubsea]="wellType?.type === 'Subsea'"
            [currentString]="currentString"
            [drillString]="drillString"
            [showLandingString]="showLandingString"
            [defaultRiser]="riser"
            [defaultHangerPressure]="defaultScreenoutHangerPressure"
            [isAnnulus]="tabType === 'annulus'"
            [user]="user"
          ></app-screenout-operation-details>
        }
      }
    </div>
  </form>
  }
</app-tool-loader>

<!-- <pre>{{ form.formGroupErrors | json }}</pre> -->